const settingActionType = {
  // settings
  FETCH_SETTINGS: "FETCH_SETTINGS",
  FETCH_SETTINGS_SUCCESS: "FETCH_SETTINGS_SUCCESS",
  FETCH_SETTINGS_FAILURE: "FETCH_SETTINGS_FAILURE",
};

export default settingActionType;
